import styled from 'styled-components/macro'
import {
  Image,
  Text
} from '@chakra-ui/react'

export const StyledImage = styled(Image)`
  width: 66px;
  height: 66px;
  object-fit: cover;
  border-radius: 5px;
`

export const StyledSubText = styled(Text)`
  width: 90%;
  margin-left: 10px;
  font-size: 15px;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
